import TextArea from "./textarea.component";

export default TextArea;
